/* globals Swiper */

export default function () {
    let wrap = '.feed-swiper';
    let element = '.feed-swiper__container';
    let list = {};

    if ($(wrap).length === 0) {
        return;
    }

    $(wrap).each((i, item) => {
        let idName = $(element, item).attr('id');

        list[idName] = new Swiper(`#${idName}`, {
            slidesPerView: 'auto',
            spaceBetween: 0,
            slidesPerGroup: 1,
            slidesOffsetBefore: 70,
            simulateTouch: false,
            roundLengths: true,
            navigation: {
                prevEl: `.feed-swiper .swiper-controls__back.${idName}`,
                nextEl: `.feed-swiper .swiper-controls__next.${idName}`,
            },
            breakpoints: {
                1280: {
                    slidesOffsetBefore: 32,
                },
                767: {
                    slidesOffsetBefore: 8,
                },
            },
        });
    });
}
